import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/home/page';
import HeatingPage from '../pages/heating/page';
import AcPage from '../pages/air-conditioning/page';
import HeatPumpsPage from '../pages/heat-pumps/page';
import PlumbingPage from '../pages/plumbing/page';
import ElectricalPage from '../pages/electrical/page';
import WaterHeatersPage from '../pages/water-heaters/page';
import InsulationPage from '../pages/insulation/page';
import AirQualityPage from '../pages/air-quality/page';
import MaintenancePlansPage from '../pages/maintenance-plans/page';
import FinancingPage from '../pages/financing/page';
import RebatesPage from '../pages/rebates-incentives/page';
import ServiceAreasPage from '../pages/service-areas/page';
import CommercialPage from '../pages/commercial/page';
import AboutPage from '../pages/about/page';
import CareersPage from '../pages/careers/page';
import ContactPage from '../pages/contact/page';
import BookAppointmentPage from '../pages/book-appointment/page';
import FurnaceInstallationPage from '../pages/furnace-installation/page';
import AcInstallationPage from '../pages/ac-installation/page';
import HeatPumpInstallationPage from '../pages/heat-pump-installation/page';
import WaterHeaterInstallationPage from '../pages/water-heater-installation/page';
import HvacMaintenancePage from '../pages/hvac-maintenance/page';
import EmergencyHvacPage from '../pages/emergency-hvac/page';
import DuctlessSystemsPage from '../pages/ductless-systems/page';
import TanklessWaterHeatersPage from '../pages/tankless-water-heaters/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/heating', element: <HeatingPage /> },
  { path: '/air-conditioning', element: <AcPage /> },
  { path: '/heat-pumps', element: <HeatPumpsPage /> },
  { path: '/plumbing', element: <PlumbingPage /> },
  { path: '/electrical', element: <ElectricalPage /> },
  { path: '/water-heaters', element: <WaterHeatersPage /> },
  { path: '/insulation', element: <InsulationPage /> },
  { path: '/air-quality', element: <AirQualityPage /> },
  { path: '/maintenance-plans', element: <MaintenancePlansPage /> },
  { path: '/financing', element: <FinancingPage /> },
  { path: '/rebates-incentives', element: <RebatesPage /> },
  { path: '/service-areas', element: <ServiceAreasPage /> },
  { path: '/commercial', element: <CommercialPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/careers', element: <CareersPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/book-appointment', element: <BookAppointmentPage /> },
  { path: '/furnace-installation', element: <FurnaceInstallationPage /> },
  { path: '/ac-installation', element: <AcInstallationPage /> },
  { path: '/heat-pump-installation', element: <HeatPumpInstallationPage /> },
  { path: '/water-heater-installation', element: <WaterHeaterInstallationPage /> },
  { path: '/hvac-maintenance', element: <HvacMaintenancePage /> },
  { path: '/emergency-hvac', element: <EmergencyHvacPage /> },
  { path: '/ductless-systems', element: <DuctlessSystemsPage /> },
  { path: '/tankless-water-heaters', element: <TanklessWaterHeatersPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
